function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import ts from "./custom-event-data.js";
import rs from "./custom-event-property-data.js";
import is from "./filter-set.js";
import ni from "./in-app-message-click-data.js";
import ns from "./purchase-data.js";
import hs from "./purchase-property-data.js";
import ur from "./push-click-data.js";
import et from "./trigger-events.js";
import { logger as N } from "../../../shared-lib/index.js";
import { getErrorMessage as si } from "../../util/error-utils.js";

var ri = /*#__PURE__*/function () {
  function ri(e, t) {
    _classCallCheck(this, ri);

    this.type = e, this.data = t, this.type = e, this.data = t;
  }

  _createClass(ri, [{
    key: "_c",
    value: function _c(e, t) {
      return ri.Ec[this.type] === e && (null == this.data || this.data.zc(t));
    }
  }, {
    key: "bt",
    value: function bt() {
      return {
        t: this.type,
        d: this.data ? this.data.bt() : null
      };
    }
  }], [{
    key: "sf",
    value: function sf(e, t) {
      var r = null;

      try {
        r = window.atob(e);
      } catch (t) {
        return N.info("Failed to unencode analytics id " + e + ": " + si(t)), !1;
      }

      return t === r.split("_")[0];
    }
  }, {
    key: "fromJson",
    value: function fromJson(e) {
      var t = e.type;
      var r = null;

      switch (t) {
        case ri.Or.OPEN:
        case ri.Or.As:
          break;

        case ri.Or.Rr:
          r = ns.fromJson(e.data);
          break;

        case ri.Or.Cc:
          r = hs.fromJson(e.data);
          break;

        case ri.Or.hr:
          r = ur.fromJson(e.data);
          break;

        case ri.Or.Ee:
          r = ts.fromJson(e.data);
          break;

        case ri.Or.Pc:
          r = rs.fromJson(e.data);
          break;

        case ri.Or.Zr:
          r = ni.fromJson(e.data);
      }

      return new ri(t, r);
    }
  }, {
    key: "Rn",
    value: function Rn(e) {
      var t,
          r = null;

      switch (e.t) {
        case ri.Or.OPEN:
        case ri.Or.As:
          break;

        case ri.Or.Rr:
          r = new ns(e.d);
          break;

        case ri.Or.Cc:
          t = e.d || {}, r = new hs(t.id, is.Rn(t.pf || []));
          break;

        case ri.Or.hr:
          r = new ur(e.d);
          break;

        case ri.Or.Ee:
          r = new ts(e.d);
          break;

        case ri.Or.Pc:
          t = e.d || {}, r = new rs(t.e, is.Rn(t.pf || []));
          break;

        case ri.Or.Zr:
          r = new ni(e.d);
      }

      return new ri(e.t, r);
    }
  }]);

  return ri;
}();

export { ri as default };
ri.Or = {
  OPEN: "open",
  Rr: "purchase",
  Cc: "purchase_property",
  hr: "push_click",
  Ee: "custom_event",
  Pc: "custom_event_property",
  Zr: "iam_click",
  As: "test"
}, ri.Ec = {}, ri.Ec[ri.Or.OPEN] = et.OPEN, ri.Ec[ri.Or.Rr] = et.Rr, ri.Ec[ri.Or.Cc] = et.Rr, ri.Ec[ri.Or.hr] = et.hr, ri.Ec[ri.Or.Ee] = et.Ee, ri.Ec[ri.Or.Pc] = et.Ee, ri.Ec[ri.Or.Zr] = et.Zr, ri.Ec[ri.Or.As] = et.As;